import { Theme, alpha } from '@mui/material';

export default {
    popper: {
        zIndex: 1500,
    },
    container: {
        backgroundColor: 'background.default',
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        boxShadow: (theme: Theme) => `0px 2px 8px 0px ${alpha(theme.palette.text.primary, 0.16)}`,
        p: 1,
        borderRadius: '4px',
        maxHeight: '45vh',
        overflowY: 'hidden',
    },
    moreLink: {
        lineHeight: 1,
        mt: 0.5,
        textAlign: 'center',
        color: 'primary.main',
        '&:hover': {
            opacity: 0.75,
            cursor: 'pointer',
        },
    },
    header: {
        minWidth: 0,
        flexShrink: 0,
        mb: 1,
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
    title: {
        color: 'primary.main',
        fontWeight: 600,
        wordWrap: 'break-word',
        mt: '1px',
        overflow: 'hidden',
        mr: 1,
    },
    status: {
        flexShrink: 0,
        alignItems: 'center',
        borderRadius: '3px',
        p: '1px 4px',
    },
    content: {
        overflow: 'auto',
        flexGrow: 1,
    },
    contentLabel: {
        color: 'primary.main',
        fontWeight: 600,
        fontSize: (theme: Theme) => `${theme.typography.fontSize - 2}px`,
    },
    contentLabelLine: {
        flexGrow: 1,
        borderTop: (theme: Theme) => `1px solid ${alpha(theme.palette.primary.main, 0.24)}`,
    },
    cutContainer: {
        position: 'relative',
        overflow: 'hidden',
        '&.active-cut:after': {
            content: "''",
            position: 'absolute',
            left: 0,
            bottom: 0,
            height: '6px',
            width: 1,
            backgroundImage: (theme: Theme) =>
                `linear-gradient(180deg, ${alpha(theme.palette.background.default, 0)} 0%, ${theme.palette.background.default} 100%)`,
        },
    },
};
